

















































































































































































































































































































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { PipelineAPI, PipelinePhaseAPI, StatusAPI } from '@/api/backend-client'
import { Status } from '@/api/model/status'
import { StatusReasonAPI } from '@/api/backend-client'
import { StatusReason } from '@/api/model/status-reason'
import { ListItemClickEvent } from '@/components/ui/list/list-item/ListItem.vue'
import { ListItemActionClickEvent } from '@/components/ui/list/list-item/ListItemAction.vue'
import { ListPlaceholderActionClickEvent } from '@/components/ui/list/list-item/ListPlaceholderItem.vue'
import { ReferralStatus } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'

@Component
export default class Statuses extends Vue {
    loadingStatuses: boolean = false
    statuses: Status[] = []
    pipelines: Pipeline[] = []

    @Ref('status-reason-container') readonly statusReasonContainerElement!: HTMLElement

    importReasonsModalVisible: boolean = false

    activeStatus: Status = null
    activePipeline: Pipeline = null
    savingStatus: boolean = false

    loadingStatusReasons: boolean = false
    showInactiveStatusReasons: boolean = false
    statusReasons: StatusReason[] = []
    newStatusReasons: StatusReason[] = []
    editingStatusReasons: StatusReason[] = []
    inUseStatusReasons: StatusReason[] = []
    removingStatusReason: StatusReason = null
    savingStatusReason: StatusReason = null

    async mounted() {
        await this.loadStatuses()
        await this.loadPipelines()

        this.activeStatus = this.statuses.find(status => status.status === ReferralStatus.OPEN)
    }

    async loadPipelines() {
        this.pipelines = (await PipelineAPI.getAll({
            company: this.$currentCompany.id,
        })).filter(pipeline => pipeline.active)
    }

    async loadStatuses() {
        this.loadingStatuses = true

        this.statuses = await StatusAPI.getAll({
            company: this.$currentCompany.id,
        })
        this.statuses.sort((a, b) => {
            const statuses = [
                ReferralStatus.OPEN,
                ReferralStatus.SUCCESSFUL,
                ReferralStatus.CLOSED,
            ]

            const aIndex = statuses.indexOf(a.status as ReferralStatus)
            const bIndex = statuses.indexOf(b.status as ReferralStatus)

            return aIndex - bIndex
        })

        this.loadingStatuses = false
    }

    async loadStatusReasons() {
        if (!this.activeStatus || !this.activePipeline) {
            return
        }

        this.loadingStatusReasons = true

        this.statusReasons = await StatusReasonAPI.getAll({
            company: this.$currentCompany.id,
            status: this.activeStatus.status,
        })
        this.statusReasons.sort((a, b) => a.name.localeCompare(b.name))
        this.newStatusReasons = []
        this.editingStatusReasons = []
        this.inUseStatusReasons = []

        this.loadingStatusReasons = false
    }

    @Watch('activePipeline')
    @Watch('activeStatus')
    hideImportModal() {
        this.importReasonsModalVisible = false
    }

    statusItemClicked(event: ListItemClickEvent<Status>) {
        const clickedStatus: Status = this.statuses.find(status => status.id === event.item.id)

        if (clickedStatus !== this.activeStatus) {
            this.activeStatus = clickedStatus
            this.loadStatusReasons()
        } else {
            this.activeStatus = null
        }
    }

    pipelineItemClicked(event: ListItemClickEvent<Pipeline>) {
        const clickedPipeline: Pipeline = this.pipelines.find(pipeline => pipeline.id === event.item.id)

        if (clickedPipeline !== this.activePipeline) {
            this.activePipeline = clickedPipeline
            this.loadStatusReasons()
        } else {
            this.activePipeline = null
        }
    }

    async savePhase(phase: PipelinePhase) {
        try {
            await PipelinePhaseAPI.update(phase.id, phase)
        } catch (error) {
            this.$notify({
                group: 'validation',
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text').toString().replace(/\n/g, '<br>'),
            })
        }
    }

    async saveStatus(status: Status) {
        this.savingStatus = true

        try {
            await StatusAPI.update(status.id, status)

            this.statuses.splice(
                this.statuses.findIndex((existingStatus => existingStatus.id === status.id)),
                1,
                status,
            )

            this.activeStatus = status
        } catch (error) {
            this.$notify({
                group: 'validation',
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text').toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.savingStatus = false
        }
    }

    statusReasonPlaceholderActionClicked(event: ListPlaceholderActionClickEvent, phase: PipelinePhase = null) {
        this.addStatusReason([phase])
    }

    statusReasonItemActionClicked(event: ListItemActionClickEvent<Status>) {
        const clickedStatusReason: StatusReason = this.statusReasons.find(statusReason => statusReason.id === event.item.id)

        this.editStatusReason(clickedStatusReason)
    }

    addStatusReason(phases: PipelinePhase[] = []) {
        const statusReason = new StatusReason(
            this.$currentCompany,
            this.activePipeline,
            phases,
            uuid(),
            this.activeStatus.status,
            this.$t('company_settings.status_reason.list.placeholder_label') + ' ' +  (this.statusReasons.length + 1),
            false,
            new Date(),
            new Date(),
        )

        this.statusReasons.push(statusReason)
        this.newStatusReasons.push(statusReason)
        this.showInactiveStatusReasons = true
    }

    editStatusReason(statusReason: StatusReason) {
        this.editingStatusReasons.push(statusReason)
    }

    cancelStatusReason(statusReason: StatusReason) {
        if (this.isNewStatusReason(statusReason)) {
            this.newStatusReasons = this.newStatusReasons.filter(newStatusReason => newStatusReason.id !== statusReason.id)
            this.statusReasons = this.statusReasons.filter(existingStatusReason => existingStatusReason.id !== statusReason.id)
        } else {
            this.editingStatusReasons = this.editingStatusReasons.filter(editingStatusReason => editingStatusReason.id !== statusReason.id)
        }
    }

    async removeStatusReason(statusReason: StatusReason) {
        this.removingStatusReason = statusReason

        try {
            if (this.isNewStatusReason(statusReason)) {
                this.newStatusReasons = this.newStatusReasons.filter(newStatusReason => newStatusReason.id !== statusReason.id)
            } else {
                await StatusReasonAPI.delete(statusReason.id)
                this.editingStatusReasons = this.editingStatusReasons.filter(editingStatusReason => editingStatusReason.id !== statusReason.id)
            }

            this.statusReasons = this.statusReasons.filter(existingStatusReason => existingStatusReason.id !== statusReason.id)
        } catch (error) {
            if (error.response && error.response.status === 405) {
                this.inUseStatusReasons.push(statusReason)
                return
            }

            this.$notify({
                group: 'validation',
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text').toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.removingStatusReason = null
        }

        // Reset status reason required if there are no status reasons remaining
        if (this.activeStatus.statusReasonRequired && this.statusReasons.length === 0) {
            this.activeStatus.statusReasonRequired = false
            this.saveStatus(this.activeStatus)
        }
    }

    async saveStatusReason(statusReason: StatusReason) {
        this.savingStatusReason = statusReason

        try {
            if (this.isNewStatusReason(statusReason)) {
                await StatusReasonAPI.create(statusReason)
                this.newStatusReasons = this.newStatusReasons.filter(newStatusReason => newStatusReason.id !== statusReason.id)
            } else {
                await StatusReasonAPI.update(statusReason.id, statusReason)
                this.editingStatusReasons = this.editingStatusReasons.filter(editingStatusReason => editingStatusReason.id !== statusReason.id)
            }

            this.statusReasons.splice(
                this.statusReasons.findIndex((existingStatusReason => existingStatusReason.id === statusReason.id)),
                1,
                statusReason,
            )
        } catch (error) {
            this.$notify({
                group: 'validation',
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text').toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.savingStatusReason = null
        }
    }

    isNewStatusReason(statusReason: StatusReason): boolean {
        return this.newStatusReasons.findIndex(newStatusReason => newStatusReason.id === statusReason.id) !== -1
    }

    isEditingStatusReason(statusReason: StatusReason): boolean {
        return this.editingStatusReasons.findIndex(editingStatusReason => editingStatusReason.id === statusReason.id) !== -1
    }

    isInUseStatusReason(statusReason: StatusReason): boolean {
        return this.inUseStatusReasons.findIndex(inUseStatusReason => inUseStatusReason.id === statusReason.id) !== -1
    }

    statusLabel(status: string): string {
        return this.$t(`referral.phaseModelStatus.${status}`).toString()
    }

    isNotStatusOpen(status: string): boolean {
        return status !== ReferralStatus.OPEN
    }

    statusReasonState(statusReason: StatusReason) {
        return {
            label: statusReason.active ? this.$t('active') : this.$t('inactive'),
            color: statusReason.active ? 'green' : 'red',
            icon: 'icon-dot',
        }
    }

    get activeStatusIsOpen(): boolean {
        return this.activeStatus?.status === ReferralStatus.OPEN
    }

    get separatorOrigin(): null|HTMLElement {
        if (!this.activePipeline) {
            return null
        }

        return document.getElementById('pipeline-' + this.activePipeline.id)
    }

    get filteredStatusReasons(): StatusReason[] {
        let statusReasons = this.statusReasons

        if (!this.showInactiveStatusReasons) {
            statusReasons = statusReasons
                .filter(statusReason => statusReason.active)
        }

        if (this.activePipeline) {
            statusReasons = statusReasons
                .filter(statusReason => {
                    return statusReason?.pipeline?.id !== null
                        && statusReason?.pipeline?.id === this.activePipeline.id
                })
        }

        return statusReasons
    }

    getFilteredStatusReasonsForPhase(phase: PipelinePhase): StatusReason[] {
        if (!phase) {
           return this.filteredStatusReasons
        }

        return this.filteredStatusReasons.filter(statusReason => statusReason?.phases.find(searchPhase => searchPhase.id === phase.id))
    }
}
